import axiosInstance from './http-services';

export const signupService = {
  signup(csrfToken: string, formSignup: any) {
    return axiosInstance.post('/familystart/signup', formSignup, {
      headers: { 'X-CSRF-Token': csrfToken },
    });
  },
};

export const memberSignupService = {
  signup(csrfToken: string, formSignup: any) {
    return axiosInstance.post('/familystart/member-signup', formSignup, {
      headers: { 'X-CSRF-Token': csrfToken },
    });
  },
};

export const midwifeSignupService = {
  signup(csrfToken: string, formSignup: any) {
    return axiosInstance.post('/familystart/midwife-signup', formSignup, {
      headers: { 'X-CSRF-Token': csrfToken },
    });
  },
};

export const pikettAllowanceService = {
  submit(csrfToken: string, request: any) {
    return axiosInstance.post('/familystart/pikett-allowance', request, {
      headers: { 'X-CSRF-Token': csrfToken },
    });
  },
};

export const hardshipApplicationService = {
  signup(csrfToken: string, formSignup: any) {
    return axiosInstance.post('/familystart/hardship-application', formSignup, {
      headers: { 'X-CSRF-Token': csrfToken },
    });
  },

  listDrafts(csrfToken: string, includeSubmitted = false) {
    return axiosInstance.get('/familystart/hardship-application/list', {
      params: includeSubmitted ? { includeSubmitted: 'true' } : {},
      headers: { 'X-CSRF-Token': csrfToken },
    });
  },

  createDraft(csrfToken: string) {
    return axiosInstance.post(
      '/familystart/hardship-application/create',
      {},
      {
        headers: { 'X-CSRF-Token': csrfToken },
      },
    );
  },

  loadDraft(csrfToken: string, caseNumber: string) {
    return axiosInstance.get('/familystart/hardship-application/load', {
      params: { caseNumber },
      headers: { 'X-CSRF-Token': csrfToken },
    });
  },

  saveDraft(csrfToken: string, caseNumber: string, data: any) {
    return axiosInstance.post(
      '/familystart/hardship-application/save',
      { caseNumber, data },
      {
        headers: { 'X-CSRF-Token': csrfToken },
      },
    );
  },

  deleteDraft(csrfToken: string, caseNumber: string) {
    return axiosInstance.post(
      '/familystart/hardship-application/delete',
      { caseNumber },
      {
        headers: { 'X-CSRF-Token': csrfToken },
      },
    );
  },

  submitDraft(csrfToken: string, caseNumber: string, data: any) {
    return axiosInstance.post(
      '/familystart/hardship-application/submit',
      { caseNumber, data },
      {
        headers: { 'X-CSRF-Token': csrfToken },
      },
    );
  },
};
